import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormSwitch,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'
import React, { useState } from 'react'
import PlayerService from 'src/service/PlayerService'
import ToastComponent from 'src/components/common/TaostComponent'

const DetailsTab = ({ detail, saveEditPlayer, onSaved, onCancel, onToggleStatus }) => {
  const player = detail.player_data
  const [loader, setLoader] = useState(false)
  const [firstName, setFirstName] = useState(player.first_name || '')
  const [lastName, setLastName] = useState(player.last_name || '')
  const [team, setTeam] = useState(player.team_id || '')
  const [position, setPosition] = useState(player.position || '')
  const [value, setValue] = useState(player.svalue || '')
  const [category, setCategory] = useState(player.external_player_type || '0')
  const [batStyle, setBatStyle] = useState(player.bat_style || '')
  const [bowlStyle, setBowlStyle] = useState(player.bowl_style || '')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoader(true)
    try {
      const res = await saveEditPlayer({
        first_name: firstName,
        last_name: lastName,
        team,
        position,
        value,
        bat_style: batStyle,
        bowl_style: bowlStyle,
      })
      if (res.status !== 200) {
        ToastComponent(res.message, 'error')
        setLoader(false)
        return
      }
      if (String(category) !== String(player.external_player_type || 0)) {
        await PlayerService.updateExternalPlayers({
          player_ids: [player.id],
          type: Number(category),
        })
      }
      ToastComponent(res.message, 'success')
      onSaved()
    } catch (e2) {
      ToastComponent('Something went wrong', 'error')
    }
    setLoader(false)
  }

  return (
    <form onSubmit={handleSubmit}>
      <CRow className="g-3">
        <CCol md={6}>
          <CFormLabel htmlFor="first_name">First Name</CFormLabel>
          <CFormInput
            id="first_name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="last_name">Last Name</CFormLabel>
          <CFormInput
            id="last_name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="team">Team</CFormLabel>
          <CFormSelect id="team" value={team} onChange={(e) => setTeam(e.target.value)}>
            <option value="">Select Team</option>
            {detail.teamList?.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </CFormSelect>
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="position">Position</CFormLabel>
          <CFormSelect
            id="position"
            disabled={detail.exists}
            value={position}
            onChange={(e) => setPosition(e.target.value)}
          >
            <option value="">Select Position</option>
            {detail.position?.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </CFormSelect>
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="value">Value</CFormLabel>
          {detail.exists ? (
            <CFormInput id="value" value={`$${player.svalue}m`} disabled />
          ) : (
            <CFormSelect id="value" value={value} onChange={(e) => setValue(e.target.value)}>
              <option value="">Select Value</option>
              {detail.value?.map((item) => (
                <option value={item.price} key={item.id}>
                  {item.price_name}
                </option>
              ))}
            </CFormSelect>
          )}
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="category">Category</CFormLabel>
          <CFormSelect id="category" value={category} onChange={(e) => setCategory(e.target.value)}>
            <option value="0">Local</option>
            {detail.categoryList?.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </CFormSelect>
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="bat_style">Bat Style</CFormLabel>
          <CFormSelect
            id="bat_style"
            value={batStyle}
            onChange={(e) => setBatStyle(e.target.value)}
          >
            <option value="">Not set</option>
            {detail.batStyle?.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </CFormSelect>
        </CCol>
        <CCol md={6}>
          <CFormLabel htmlFor="bowl_style">Bowl Style</CFormLabel>
          <CFormSelect
            id="bowl_style"
            value={bowlStyle}
            onChange={(e) => setBowlStyle(e.target.value)}
          >
            <option value="">Not set</option>
            {detail.bowlStyle?.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </CFormSelect>
        </CCol>
      </CRow>

      <hr className="my-4" />

      <div className="fw-bold mb-2">Player Status</div>
      <CFormSwitch
        label={player.is_active === 1 ? 'Active' : 'Inactive '}
        checked={player.is_active === 1}
        onChange={() => onToggleStatus(player.is_active === 1 ? 0 : 1)}
      />

      <div className="d-flex justify-content-between align-items-center mt-4">
        {/* <CButton
          color="danger"
          variant="ghost"
          type="button"
          onClick={() => onToggleStatus(player.is_active === 1 ? 0 : 1)}
        >
          {player.is_active === 1 ? 'Deactivate' : 'Activate'}
        </CButton> */}
        <div className="d-flex gap-2">
          <CButton color="secondary" variant="outline" type="button" onClick={onCancel}>
            Cancel
          </CButton>
          <CLoadingButton type="submit" color="primary" loading={loader}>
            Save Changes
          </CLoadingButton>
        </div>
      </div>
    </form>
  )
}

export default DetailsTab
